import styled, {css} from "styled-components"

interface HorizontalBannerCssProps {
  position?: HorizontalBannerPositions
  bgColor?: string
}

export enum HorizontalBannerPositions {
  BOTTOM = "BOTTOM",
  ABSOLUTE = "ABSOLUTE"
}
// The main wrapper consisting on only dimensions, spacing, positioning and a flex display
const HorizontalBanner = styled.div<HorizontalBannerCssProps>`
  width: 100%;
  min-height: 52px;
  display: flex;
  ${({theme, position, bgColor}) => css`
    background-color: ${bgColor || theme.colors.greys.dark};
    padding: ${theme.spacing.one};

    ${position === HorizontalBannerPositions.ABSOLUTE &&
    `
      position: absolute;
      right: 0;
      left: 0;
    `}
    ${position === HorizontalBannerPositions.BOTTOM &&
    `
      position: fixed;
      bottom: 0;
      z-index: 999;
    `}
  `}
`

export default HorizontalBanner
